<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <monthly-statement-table></monthly-statement-table>
    </b-col>
</template>

<script>
    import MonthlyStatementTable from './monthly-statement/MonthlyStatementTable.vue';
    export default {
        components: { MonthlyStatementTable },
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/MonthlyStatementContent.vue